import React from 'react';
import Event from '../components/Event/Event';
import EventPreview from '../components/Event/EventPreview';

const EventPage = () => {
  return (
    <div className="pt-20">
      <Event/>
      <EventPreview/>
    </div>
  );
};

export default EventPage;